import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    margin-bottom: 1rem;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
    }
  }
`;

export const TablesContainer = styled.div`
  width: 100%;
  padding: 1rem;

  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

  > .MuiPaper-root {
    height: auto;
    max-height: none;
    padding: 0;
    box-shadow: none;
  }
`;

export const Details = styled.div`
  margin-top: 1rem;

  h4 {
    margin: 0 0 0.75rem;
    font-size: 1rem;
  }
`;
